module.exports = __webpack_public_path__ + "img/e_2_6_r.fd634ec9.png";